import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const ProvidersListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return (
    <Common.Header title={t('providers.title')}>
      <div className="btn-group pull-right">
        {canAdd && (
          <Form.Link
            to={createRoute(companyId, subcompanyId, 'providers/add')}
            className="btn btn-info"
          >
            {t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
};

export default translate()(ProvidersListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/ProvidersListHeader.js